import React, { Fragment } from 'react';
import styles from './styles.scss';
import { Col, Row } from 'Components/Grid';
import Dropdown from 'Components/Dropdown';
import Input from 'Components/Input';
import { FORM_SALUTATIONS } from './contactFormConstants';

const PersonalDataFormSection = ({
  errors,
  handleChange,
  title,
  firstName,
  lastName,
  street,
  houseNumber,
  postalCode,
  city,
  country,
  email,
  telephone,
  hideAddress,
  hideTitle,
  secondaryHeader,
  customerSupportMessage,
  titleIsOptional,
}) => (
  <Fragment>
    <Row>
      <Col>
        <h3 className={styles.sectionHeadline} aria-label="Persönliche Daten">
          Persönliche Daten
        </h3>
        {secondaryHeader && (
          <>
            <div className={styles.secondaryHeader} aria-hidden="true">
              {secondaryHeader}
            </div>
            <div className="sr-only">{secondaryHeader.replace('*', '"Pflichtangabe"')}</div>
          </>
        )}
      </Col>
    </Row>
    <Row className={styles.marginS}>
      {!hideTitle && (
        <Col cols={12} m={6}>
          <Dropdown
            name="title"
            label={titleIsOptional ? 'Anrede wählen (optional)' : 'Anrede wählen*'}
            value={title}
            onChange={handleChange}
            options={FORM_SALUTATIONS}
            errorMessage={errors.title}
          />
        </Col>
      )}
    </Row>
    <Row className={styles.marginS}>
      <Col cols={12} m={6}>
        <Input
          label="Vorname*"
          name="firstName"
          value={firstName}
          errorMessage={errors.firstName}
          onChange={handleChange}
        />
      </Col>
      <Col cols={12} m={6}>
        <Input
          label="Nachname*"
          name="lastName"
          value={lastName}
          errorMessage={errors.lastName}
          onChange={handleChange}
        />
      </Col>
    </Row>
    {!hideAddress && (
      <div>
        <Row className={styles.marginS}>
          <Col cols={12} m={8}>
            <Input
              label="Straße"
              name="street"
              value={street}
              errorMessage={errors.street}
              onChange={handleChange}
            />
          </Col>
          <Col cols={12} m={4}>
            <Input
              label="Nr."
              name="houseNumber"
              value={houseNumber}
              errorMessage={errors.houseNumber}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <Row className={styles.marginS}>
          <Col cols={12} m={3}>
            <Input
              label="PLZ"
              name="postalCode"
              value={postalCode}
              errorMessage={errors.postalCode}
              onChange={handleChange}
            />
          </Col>
          <Col cols={12} m={4}>
            <Input
              label="Ort"
              name="city"
              value={city}
              errorMessage={errors.city}
              onChange={handleChange}
            />
          </Col>
          <Col cols={12} m={5}>
            <Input
              label="Land"
              name="country"
              value={country}
              errorMessage={errors.country}
              onChange={handleChange}
              disabled
            />
          </Col>
        </Row>
      </div>
    )}
    <Row className={styles.marginS}>
      <Col cols={12} m={6}>
        <Input
          label="E-Mail-Adresse*"
          name="email"
          value={email}
          errorMessage={errors.email}
          onChange={handleChange}
        />
      </Col>
      <Col cols={12} m={6}>
        <Input
          label="Rufnummer"
          name="telephone"
          value={telephone}
          errorMessage={errors.telephone}
          onChange={handleChange}
          maxLength={25}
        />

        {/**
         * The field below acts as a honeypot (trap) for non-human users.
         */}
        <div style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
          <Input
            tabIndex={-1}
            label="Nachricht an die Biene"
            name="customerSupportMessage"
            value={customerSupportMessage}
            errorMessage={errors.customerSupportMessage}
            onChange={handleChange}
          />
        </div>
      </Col>
    </Row>
  </Fragment>
);

export default PersonalDataFormSection;
